export default "__VITE_ASSET__B5IAagGQ__"